var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('page-title',{attrs:{"title":"Log Out"}}),_c('b-row',[_c('b-col',[_c('p',[_vm._v("You have been logged out.")]),_c('b-link',{attrs:{"to":"/"}},[_vm._v("Continue")])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }